// client/src/components/AdminHeader.js
// Header for admin mode with organization selector and breadcrumbs

import React from 'react';
import { HeadlineMedium } from './Typography';
import AdminTopRightMenu from './AdminTopRightMenu';

const AdminHeader = ({ organizations, currentOrgId, onOrgChange, activeSection, onModeSwitch, onLogOut }) => {
  const showOrgSelector = organizations.length > 1;

  const getSectionTitle = (section) => {
    switch (section) {
      case 'account':
        return 'Organization';
      case 'organizations':
        return 'Organizations';
      case 'students':
        return 'Students';
      case 'reporting':
        return 'Reporting';
      case 'marketing':
        return 'Marketing';
      default:
        return 'Admin';
    }
  };

  return (
    <header className="px-6 py-4">
      <div className="flex items-center justify-between gap-4">
        <div className="flex flex-col gap-3 min-w-0">
          <HeadlineMedium color="gray-900">
            {getSectionTitle(activeSection)}
          </HeadlineMedium>

          {showOrgSelector && (
            <div className="max-w-md">
              <select
                id="admin-org-select"
                value={currentOrgId || ''}
                onChange={(e) => onOrgChange(e.target.value)}
                aria-label="Organization"
                className="w-full min-h-[44px] border border-gray-300 rounded-md px-3 py-2 bg-white text-gray-900 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                {organizations.map((org) => (
                  <option key={org.id} value={org.id}>
                    {org.name || org.id}
                  </option>
                ))}
              </select>
            </div>
          )}
        </div>

        <AdminTopRightMenu
          onLogOut={onLogOut}
          onModeSwitch={onModeSwitch}
        />
      </div>
    </header>
  );
};

export default AdminHeader;
